import { render } from "./DocumentRequirementForm.vue?vue&type=template&id=0d468033&ts=true"
import script from "./DocumentRequirementForm.vue?vue&type=script&lang=ts"
export * from "./DocumentRequirementForm.vue?vue&type=script&lang=ts"

import "./DocumentRequirementForm.vue?vue&type=style&index=0&id=0d468033&lang=scss"

import exportComponent from "/builds/harapan-jaya/ecosystem/web-hrd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__